/**
 * Dead-simple, dependency-free toast bus. `toast(msg)` dispatches a window
 * event; the <Toaster/> mounted in App listens and renders it. No store, no
 * context, no provider tree — any module can fire a toast without wiring.
 */
export type ToastKind = 'success' | 'error' | 'info'

export interface ToastEvent {
  id: number
  message: string
  kind: ToastKind
}

let seq = 0

export function toast(message: string, kind: ToastKind = 'info') {
  if (typeof window === 'undefined') return
  window.dispatchEvent(
    new CustomEvent('aska:toast', { detail: { id: ++seq, message, kind } })
  )
}
